import React, { useState } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { storage, db } from "../../firebase";
import { useParams } from "react-router-dom";
import "../../Styles/Documentacion.css";
import { GetHubInfo } from "../../Hooks/UseHubName";
import GetUserData from "../../Hooks/GetUserData";

const UploadDocument = ({ folderId }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const { hubId } = useParams();
  const hubInfo = GetHubInfo(hubId);
  const { userData } = GetUserData();

  // Convertir archivo a base64
  const fileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]); // quitamos el prefijo "data:..."
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file || !folderId) return;

    setUploading(true);

    try {
      if (!hubInfo.useBlocktrace) {
        // === Subida normal a Firebase Storage ===
        const storageRef = ref(
          storage,
          `${hubId}/documents/${folderId}/${file.name}`
        );
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);

        const q = query(
          collection(db, "private-hubs", hubId, "Documentos"),
          where("name", "==", file.name),
          where("folderId", "==", folderId)
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          await addDoc(collection(db, "private-hubs", hubId, "Documentos"), {
            name: file.name,
            url,
            folderId,
            createdAt: new Date(),
          });
        }

        alert("Documento subido con éxito");
      } else {
        // === Subida a Blocktrace vía Cloud Function ===
        const cleanFileName = file.name
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replace(/[^a-zA-Z0-9._-]/g, "_");

        // Convertimos el archivo a base64
        const fileBase64 = await fileToBase64(file);

        // URL de la Cloud Function
        const cloudFunctionUrl =
          "https://us-central1-lyseis-tools-hub.cloudfunctions.net/blocktraceUpload";

        console.log("DEBUG - Uploading file to Blocktrace:", {
          fileName: cleanFileName,
          userOrigin: userData.email,
          userDestination: hubId,
          folderId,
        });

        // Llamada POST
        const response = await fetch(cloudFunctionUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            fileBase64,
            fileName: cleanFileName,
            userOrigin: userData.email,
            userDestination: hubId,
            folderId: folderId,
            processName: "UPLOAD_DOCUMENT",
          }),
        });

        const data = await response.json();

        if (!response.ok) throw new Error(data.error || "Error desconocido");

        console.log("DEBUG - Cloud Function response:", data);

        alert("Documento subido con éxito a Blocktrace");
        setFile(null);
      }
    } catch (error) {
      console.error("Error subiendo documento:", error);
      alert("Error al subir el documento");
    } finally {
      setUploading(false);
    }
  };

  return (
    <form onSubmit={handleUpload} className="upload-document-form">
      <label className="block text-sm font-semibold text-blue-800 mb-2">
        Subir documento:
      </label>
      <input
        type="file"
        onChange={(e) => setFile(e.target.files[0])}
        className="w-full mb-2 border border-gray-300 p-2 rounded"
      />
      <button
        type="submit"
        disabled={!file || uploading}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50 w-full"
      >
        {uploading ? "Subiendo..." : "Subir"}
      </button>
    </form>
  );
};

export default UploadDocument;
